'use strict';

var React = require('react');

var SvgOnlineStoreMinor = function SvgOnlineStoreMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.96 2.5c.448 0 .863.24 1.085.63l1.79 3.133c.108.188.165.402.165.62v.867c0 .965-.497 1.815-1.25 2.305v1.445a2.75 2.75 0 0 1-2.75 2.75h-.5v1.25h.75a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h.75v-1.25h-.5a2.75 2.75 0 0 1-2.75-2.75v-1.445a2.748 2.748 0 0 1-1.25-2.305v-.867c0-.218.057-.432.165-.62l1.79-3.133a1.25 1.25 0 0 1 1.085-.63h7.92Zm-7.775 1.5-1.685 2.95v.8c0 .69.56 1.25 1.25 1.25h.25c.69 0 1.25-.56 1.25-1.25v-.5a.75.75 0 0 1 1.5 0v.5a1.25 1.25 0 1 0 2.5 0v-.5a.75.75 0 0 1 1.5 0v.5c0 .69.56 1.25 1.25 1.25h.25c.69 0 1.25-.56 1.25-1.25v-.8l-1.685-2.95h-7.63Zm8.065 6.5h-.25a2.742 2.742 0 0 1-2-.863 2.742 2.742 0 0 1-2 .863 2.742 2.742 0 0 1-2-.863 2.742 2.742 0 0 1-2 .863h-.25v1c0 .69.56 1.25 1.25 1.25h6c.69 0 1.25-.56 1.25-1.25v-1Zm-5.25 5v-1.25h2v1.25h-2Z"
  }));
};
SvgOnlineStoreMinor.displayName = "OnlineStoreMinor";

exports.SvgOnlineStoreMinor = SvgOnlineStoreMinor;
